export const STORE_RESET = '@@STORE/RESET';